module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/menu/menu.component.scss
// module id = ./src/app/menu/menu.component.scss
// module chunks = main